export default __webpack_public_path__ + "static/media/icon-phone-black.7b32648b.svg";